import { HandType, TournFlags2 } from '@ps/web-poker-types';
import BitSet from 'bitset';

import { legacyHandTypeToAssetNameMap } from '../types';

import {
  BASE_POKER_STR,
  BUY_IN_RANGES_SNG,
  NGCDN_BASE_URL,
  Structure,
  TILE_IMAGE_FORMAT,
  getRailCdnBaseUrl,
  isMixedGame
} from './game';
import { getBuyInCategory, getTournGroupStr, isSwapShowFusion } from './helpers';
import defaultImage from './imageCash';

export default function imageSngFormatter(
  game: HandType,
  structure: number,
  buyIn: number,
  isHiLo: number,
  satelliteTarget: number,
  tournGroup: number,
  maxPerTable: number,
  tournFlags2: string,
  isThemeV2Image?: boolean
) {
  const buyInCategory = `_${getBuyInCategory(buyIn, BUY_IN_RANGES_SNG)}`;
  const railCdnBaseUrl = getRailCdnBaseUrl(!!isThemeV2Image);

  if (isSwapShowFusion(game)) {
    return defaultImage(game, structure, buyIn, 0, isHiLo, 0, isThemeV2Image);
  }

  if (satelliteTarget !== 0) {
    return `${railCdnBaseUrl}${BASE_POKER_STR}satellite${TILE_IMAGE_FORMAT}`;
  }

  if (tournGroup > 0) {
    return `${NGCDN_BASE_URL}${BASE_POKER_STR}${getTournGroupStr(
      tournGroup,
      isThemeV2Image
    )}${TILE_IMAGE_FORMAT}`;
  }

  if (maxPerTable === 2 && structure === Structure.NL && game === HandType.HOLDEM) {
    return `${railCdnBaseUrl}${BASE_POKER_STR}heads_up${TILE_IMAGE_FORMAT}`;
  }

  if (tournFlags2 && tournFlags2 !== '0') {
    const hexMask = Number(tournFlags2).toString(16);
    if (BitSet.fromHexString(hexMask).get(Math.log2(TournFlags2.TOURNSCRIPT_FLAG2_KNOCKOUT))) {
      return `${railCdnBaseUrl}${BASE_POKER_STR}knockouts${TILE_IMAGE_FORMAT}`;
    }
  }

  if (isMixedGame(game)) return defaultImage(game, structure, buyIn, 0, isHiLo, 0, isThemeV2Image);

  const gameStr = legacyHandTypeToAssetNameMap[game].toLowerCase();
  const structureStr = Structure[structure].toLowerCase();
  const hiLoStr = isHiLo === 1 ? '_hl' : '';

  return `${railCdnBaseUrl}${BASE_POKER_STR}${structureStr}_${gameStr}${hiLoStr}${buyInCategory}${TILE_IMAGE_FORMAT}`;
}
